import axios from 'axios';

const prod = 'https://www.medway.com.br/wp-json/wp/v2/';
const dev = 'https://fmedway.com.br/wp-json/wp/v2/';
// const dev = 'http://local.medway/wp-json/wp/v2/';

const apiWordpress = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? dev : prod,
});

export default apiWordpress;
